var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "h4",
      {
        staticClass: "text-uppercase size-md",
        staticStyle: {
          "letter-spacing": "var(--letter-spacing-2xl)",
          "font-weight": "700",
        },
      },
      [
        _vm.isShowingFamilyName
          ? _c(
              "span",
              {
                staticClass:
                  "display-inline-block margin-bottom-2xs padding-x-2xs padding-y-3xs size-sm",
                style: _vm.selectStyle,
              },
              [_vm._v("\n      " + _vm._s(_vm.familyName) + "\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("span", { staticClass: "display-block" }, [
          _vm._v(_vm._s(_vm.styleName)),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("p", { staticClass: "margin-0 size-sm" }, [
      _vm._v("\n    " + _vm._s(_vm.styleDescription) + "\n  "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }